import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import maintenanceLogo from "@/assets/maintenance-logo.png";

const MaintenancePage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) throw error;
      toast.success("Logged in successfully");
      window.location.reload();
    } catch (err: any) {
      toast.error(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 w-screen h-screen overflow-hidden bg-[hsl(150,20%,6%)] flex items-center justify-center">
      <div
        className="flex flex-col items-center gap-10 px-6 animate-fade-in-up"
        style={{ animationDuration: "1s" }}
      >
        <img
          src={maintenanceLogo}
          alt="PadelCorner"
          className="w-[280px] sm:w-[360px] md:w-[420px] select-none pointer-events-none"
          draggable={false}
        />

        <div className="flex flex-col items-center gap-3">
          <h1
            className="text-white text-2xl sm:text-3xl md:text-4xl font-bold tracking-[0.25em] text-center font-display"
          >
            DRĪZ ATVĒRSIMIES
          </h1>
          <p className="text-white/50 text-xs sm:text-sm tracking-[0.2em] font-light font-body mt-1">
            Raketes · Apavi · Apģērbs · Somas
          </p>
          <p
            className="text-white/40 text-sm sm:text-base tracking-[0.35em] font-light font-body"
          >
            PADELCORNER.LV
          </p>
          <a
            href="https://www.instagram.com/padelcorner.lv"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 text-white/30 hover:text-white/70 transition-colors duration-200"
            aria-label="Instagram"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
            </svg>
          </a>
        </div>
      </div>

      {/* Login button */}
      <button
        onClick={() => setShowLogin(true)}
        className="fixed bottom-6 right-6 px-8 py-3 bg-primary hover:bg-primary/80 text-primary-foreground font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 text-base tracking-wide z-50"
      >
        Login
      </button>

      {/* Login modal */}
      {showLogin && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
          onClick={(e) => { if (e.target === e.currentTarget) setShowLogin(false); }}
        >
          <div className="bg-card rounded-2xl shadow-2xl p-8 w-full max-w-sm mx-4 relative">
            <button
              onClick={() => setShowLogin(false)}
              className="absolute top-3 right-3 text-muted-foreground hover:text-foreground text-xl leading-none"
              aria-label="Close"
            >
              ✕
            </button>

            <h2 className="font-display text-2xl font-bold text-center mb-1 text-foreground">Login</h2>
            <p className="text-sm text-muted-foreground text-center mb-6">
              Only existing accounts can log in during maintenance.
            </p>

            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label htmlFor="m-email" className="block text-sm font-medium text-foreground mb-1">Email</label>
                <input
                  id="m-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="you@example.com"
                />
              </div>
              <div>
                <label htmlFor="m-pass" className="block text-sm font-medium text-foreground mb-1">Password</label>
                <input
                  id="m-pass"
                  type="password"
                  required
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
                  placeholder="••••••••"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full py-2.5 rounded-lg bg-primary text-primary-foreground font-semibold text-sm hover:bg-primary/90 transition-colors disabled:opacity-50"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenancePage;
